import { api } from './client'

/**
 * F-063 (TASK-0317, REQ-242-001): client di `SavedViewsController` (`/api/saved-views`). Una vista salva
 * filtri, ordinamento e colonne di un elenco (oggi `contracts` e `leads`) con un nome; e' Privata (solo
 * chi la crea), di Team (chi crea e il suo sottoalbero) o Aziendale (tutti; crearla richiede il ruolo
 * Manager, il server risponde 403 agli altri). Modifica/eliminazione: solo proprietario o Admin.
 */
export type SavedViewPage = 'contracts' | 'leads'
export type SavedViewVisibility = 'Privata' | 'Team' | 'Aziendale'

export const SAVED_VIEW_VISIBILITY_LABELS: Record<SavedViewVisibility, string> = {
  Privata: 'Privata (solo io)',
  Team: 'Team (io e il mio gruppo)',
  Aziendale: 'Aziendale (tutti)',
}

/** Oggetto opaco per il server: al massimo queste chiavi, al massimo 8 KB. */
export interface SavedViewState {
  filters?: Record<string, unknown>
  sort?: Record<string, unknown>
  columns?: string[]
  grouping?: unknown
}

export interface SavedView {
  id: number
  pageKey: SavedViewPage
  name: string
  visibility: SavedViewVisibility
  ownerUserId: number
  isOwner: boolean
  state: SavedViewState
  createdAt: string
  updatedAt: string | null
}

export interface SavedViewRequest {
  pageKey: SavedViewPage
  name: string
  visibility: SavedViewVisibility
  state: SavedViewState
}

export const savedViewsApi = {
  list: (page: SavedViewPage) =>
    api<{ items: SavedView[] }>(`/api/saved-views?page=${encodeURIComponent(page)}`),
  create: (data: SavedViewRequest) =>
    api<SavedView>('/api/saved-views', { method: 'POST', body: JSON.stringify(data) }),
  update: (id: number, data: SavedViewRequest) =>
    api<SavedView>(`/api/saved-views/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  remove: (id: number) => api<void>(`/api/saved-views/${id}`, { method: 'DELETE' }),
}
